import { render } from "./BusinessProfile.vue?vue&type=template&id=c6a81a8e"
import script from "./BusinessProfile.vue?vue&type=script&lang=js"
export * from "./BusinessProfile.vue?vue&type=script&lang=js"

import "./BusinessProfile.vue?vue&type=style&index=0&id=c6a81a8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__